import React, { forwardRef } from 'react';
import { Pie } from 'react-chartjs-2';

const CREDIT_GRADE_COLOURS = {
  'AAA': '#012341',
  'AA': '#2f5596',
  'A': '#599be2',
  'BBB': '#39aec5',
  'BB and Lower': '#f3bd48'
};

const DISPLAY_ORDER = ['AAA', 'AA', 'A', 'BBB', 'BB and Lower'];

const CreditExposureChart = forwardRef(({ creditExposure }, ref) => {
  if (!creditExposure || Object.keys(creditExposure).length === 0) {
    return <div className="chart-placeholder-text" style={{ color: '#999', fontSize: '10pt' }}>Credit data not available</div>;
  }

  const orderedLabels = [];
  const orderedValues = [];
  const orderedColours = [];

  DISPLAY_ORDER.forEach(grade => {
    if (creditExposure[grade] && creditExposure[grade] > 0) {
      orderedLabels.push(grade);
      orderedValues.push(creditExposure[grade]);
      orderedColours.push(CREDIT_GRADE_COLOURS[grade] || '#999999');
    }
  });

  if (orderedLabels.length === 0) {
    return <div className="chart-placeholder-text" style={{ color: '#999', fontSize: '10pt' }}>Credit data not available</div>;
  }

  const chartData = {
    labels: orderedLabels,
    datasets: [{
      data: orderedValues,
      backgroundColor: orderedColours,
      borderWidth: 0
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw.toFixed(1)}%`
        }
      }
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', width: '100%' }}>
      <div style={{ width: '120px', height: '120px', flexShrink: 0 }}>
        <Pie ref={ref} data={chartData} options={options} />
      </div>
      <div className="credit-legend" style={{ flex: 1, textAlign: 'left' }}>
        {orderedLabels.map((label, idx) => (
          <div key={idx} className="legend-item" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px', fontSize: '9pt' }}>
            <span style={{
              width: '12px',
              height: '12px',
              backgroundColor: orderedColours[idx],
              display: 'inline-block',
              borderRadius: '2px'
            }}></span>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
});

export default CreditExposureChart;
